var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "msnvy4r6pa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.839216 0 0 0 0 0.709804 0 0 0 0 0.427451 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-965 -72) translate(825 72)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z",
    transform: "translate(140)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.647 4.6c-2.723 0-4.92 2.196-4.92 4.92 0 2.722 2.197 4.919 4.92 4.919s4.92-2.197 4.92-4.92S12.37 4.6 9.647 4.6zm-.064 8.178c-1.757 0-3.194-1.433-3.194-3.195 0-1.762 1.432-3.194 3.194-3.194s3.195 1.432 3.195 3.194-1.437 3.195-3.195 3.195zm6.261-8.306c0 .64-.514 1.15-1.15 1.15-.639 0-1.15-.515-1.15-1.15 0-.635.515-1.15 1.15-1.15.636 0 1.15.515 1.15 1.15zm3.255 1.16c-.072-1.536-.423-2.896-1.548-4.016C16.431.495 15.071.144 13.536.067c-1.582-.09-6.324-.09-7.906 0C4.1.14 2.74.491 1.615 1.611.491 2.731.145 4.091.067 5.627c-.09 1.583-.09 6.326 0 7.908.073 1.536.424 2.896 1.548 4.016 1.125 1.12 2.48 1.471 4.015 1.548 1.582.09 6.324.09 7.906 0 1.535-.072 2.895-.423 4.015-1.548 1.12-1.12 1.471-2.48 1.548-4.016.09-1.582.09-6.321 0-7.903zm-1.99 9.53c-.333.837-.978 1.482-1.82 1.82-1.26.5-4.25.384-5.642.384-1.392 0-4.387.111-5.642-.384-.838-.333-1.483-.978-1.82-1.82-.5-1.26-.385-4.25-.385-5.643 0-1.392-.11-4.386.385-5.642.333-.837.978-1.482 1.82-1.82 1.26-.5 4.25-.384 5.642-.384 1.393 0 4.387-.111 5.643.384.837.333 1.482.978 1.82 1.82.5 1.26.384 4.25.384 5.642 0 1.393.115 4.387-.384 5.643z",
    transform: "translate(140) translate(3.333 3.333)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d077c465.svg";
export { ForwardRef as ReactComponent };